import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>{`Skills`}</h4>
    <p>{`Excellent to engage in complex, challenging and diverse projects to deliver collective results.`}<br />{`
Very dynamic and good speaker with extraordinary written and presentation skills.`}<br />{`
Skilled in Customer Satisfaction, work-ethics, willing to work overtime and flexible shifts.`}<br />{`
Ability to work both independently and as part of a professional team.`}<br />{`
Highly motivated, quick learner, results-driven, friendly, and helpful.`}</p>
    <h4>{`Technical Skills`}</h4>
    <p>{`Languages: Python, SQL, JavaScript, HTML, PHP `}<br />{`
Technologies: Microsoft Excel & PowerPoint, Power BI, Tableau, PostgreSQL, Flask, Django, Gatsby, Bootstrap, Google Workspace, Office 365, Git, AWS. `}<br />{`
Libraries: Pivot Tables, Power Query, NumPy, Pandas, Seaborn, Matplotlib, Sci-kit Learn.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      